"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const with_form_field_1 = require("./with-form-field");
const checkbox_1 = require("@atlaskit/checkbox");
exports.CheckboxField = with_form_field_1.withFormField(checkbox_1.Checkbox);
